if (!customElements.get('oswaal-related-media')) {
  customElements.define('oswaal-related-media', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;

      const source = this.querySelector(
        'template[data-original-media]'
      );

      if (!source) return;

      this.ready = true;

      const fragment = source.content.cloneNode(true);

      const hosts = new Set([
        'youtube.com',
        'www.youtube.com',
        'youtube-nocookie.com',
        'www.youtube-nocookie.com'
      ]);

      fragment.querySelectorAll('iframe[src]').forEach(original => {
        let url;

        try {
          url = new URL(
            original.getAttribute('src'),
            location.origin
          );
        } catch {
          return;
        }

        const match = url.pathname.match(
          /^\/embed\/([A-Za-z0-9_-]{11})\/?$/
        );

        if (
          !hosts.has(url.hostname) ||
          !match ||
          !['https:', 'http:'].includes(url.protocol)
        ) {
          return;
        }

        url.protocol = 'https:';
        url.searchParams.delete('autoplay');

        const title = original.title || 'Video';

        const facade = document.createElement('div');
        facade.className = 'oswaal-video-facade';

        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute(
          'aria-label',
          `Play video: ${title}`
        );

        const thumbnail = document.createElement('img');
        thumbnail.src =
          `https://i.ytimg.com/vi/${match[1]}/hqdefault.jpg`;
        thumbnail.alt = '';
        thumbnail.width = 480;
        thumbnail.height = 360;
        thumbnail.loading = 'lazy';
        thumbnail.decoding = 'async';

        const play = document.createElement('span');
        play.textContent = '▶';
        play.setAttribute('aria-hidden', 'true');

        button.append(thumbnail, play);

        button.addEventListener('click', () => {
          if (typeof window.pauseAllMedia === 'function') {
            window.pauseAllMedia();
          }

          const iframe = document.createElement('iframe');

          url.searchParams.set('autoplay', '1');

          iframe.src = url.href;
          iframe.title = title;
          iframe.allow =
            'autoplay; encrypted-media; picture-in-picture; fullscreen';
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';

          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('tabindex', '0');

          button.replaceWith(iframe);
          iframe.focus();
        }, { once: true });

        facade.append(button);
        original.replaceWith(facade);
      });

      this.replaceChildren(fragment);
    }
  });
}
